/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface HrDepartment { 
    id?: string;
    name?: string;
    description?: string;
    department_type_id?: string;
    code?: string;
    sort_index?: number;
    parent_id?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    address?: string;
    province?: string;
    district?: string;
    phone_number?: string;
    type_of_business?: string;
    website?: string;
    email?: string;
    founded_date?: Date;
    tax_code?: string;
    inverseparent_?: Array<HrDepartment>;
}